export const nbsp:string = "\u00A0";
export const wbsp:string = "\u0020";